import { createFileRoute } from '@tanstack/react-router'
import { StaffBencana } from '../../../../components/StaffBencana'

export const Route = createFileRoute('/desa/$slug/dashboard/bencana')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffBencana desaId={desaId} />
  },
})
